<template>
    <div id="vehicle_types_deposit" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="vehicleTypeDepositHeader" v-if="$route.params.id > 0">Update Asset Type Deposit</span>
                    <span class="page-title" id="vehicleTypeDepositHeader" v-else>Add Asset Type Deposit</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackVehicleList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content asset-type-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="VehicleTypeForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                    <label class="control-label"  for="vehicle_type_id">Asset Type:</label>
                                    <v-select v-model="vehicle_type_id" name="vehicle_type_id" placeholder="Select Vehicle Type."
                                            label="text"
                                            :options="vehicletypeArr">
                                    </v-select>
                                    <div class="field-error">{{ vehicle_type_error_msg }}</div>
                                </div>
                                </div>

                                <h5>Deposit</h5>
                                <div v-if="deprows && deprows.length > 0" class="table-responsive-sm">
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" class="w-50 require">Pool</th>
                                                <th scope="col" class="w-25 require">Deposit</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(dep, depindex) in deprows" :key="depindex">
                                                <td>
                                                    <v-select class="section-id" v-model="dep.pool" name="pool" placeholder="Select Pool"
                                                        label="text"
                                                        :options="assetPoolArr">
                                                    </v-select>
                                                    <div class="field-error">{{ dep.pool_error_msg }}</div>
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control" v-model="dep.deposit_required" id="deposit_required" placeholder="Enter Required Deposit" name="deposit_required" @keypress="isAmountCheck($event)">
                                                    <div class="field-error">{{ dep.deposit_error_msg }}</div>
                                                </td>
                                                <td class="text-center valign-middle">
                                                    <template v-if="deprows.length != 1">
                                                         <a href="javascript:void(0)" v-on:click.prevent="removeDepElement(depindex);"> <i class="fp-remove"></i> </a>
                                                    </template>
                                                    <template v-else>
                                                        <span class="close-row"> _ </span>
                                                    </template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="btn-groups">
                                        <button type="submit" v-on:click.prevent="addDepRow()" class="btn btn-primary">
                                            <i class="fp-add"></i> Add Deposit Line
                                        </button>
                                    </div>
                                </div>
                                <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                    <strong id="errorMsg" class="field-error"></strong>
                                </div>
                                <div class="btn-groups mt-4">
                                    <button type="submit" id="createVehicleTypeDepositBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateVehicleTypeDeposit" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createVehicleTypeDepositBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateVehicleTypeDeposit" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="cancelVehicleTypeDepositBtn" class="btn btn-tertiary" v-on:click.prevent="BackVehicleList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';


export default {
  name: "VehicleTypeDeposit",
  mixins:[commonMixins,contractMixins],
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Asset Type Deposit | " +process.env.COPYRIGHT_NAME : "Create Asset Type Deposit | " +process.env.COPYRIGHT_NAME}
  },
  data: () => ({
    permissions: [],
    vehicletypeArr:[],
    vehicle_type_id:'',
    vehicle_type_error_msg:'',
    cantAccessPage: "",
    loading:false,
    deprows:[],
    assetPoolArr:[],
  }),
  watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_asset_type') {
                        self.cantAccessPage = true;
                    }
                }
            }
        }
  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        var path = window.location.pathname;
        var segments = path.split("/");

        if (segments[3]) {
            self.loadVehicleTypes();
        }else{
            self.deprows.push({
                dep_id:0,
                pool: '',
                deposit_required:'',
                deposit_error_msg:'',
                pool_error_msg:'',
            });
        }
        // self.getsectionArr();
        self.getAssetType();
        self.loadFieldData(['vehicle_pool']);
  },
  methods: {

    BackVehicleList() {
      var self = this;
      self.$router.push("/asset-deposit-type/list");
    },

    checkSelected() {
        var self = this;
        if (self.is_default != true) {
            self.checkboxValue = 1;
        } else {
            self.checkboxValue = 0;
        }
    },
    getAssetType(){

        var self = this;

        $.ajax({
            url: process.env.ROOT_API + "/trucktype/search",
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
           
            success: function (data) {
                self.loading = false;
                self.vehicletypeArr = data;
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'contract-asset-get-section-rate')
            }
        });
    },

    CreateVehicleTypeDeposit(flag) {
      var self = this;

        var error = false;

      self.vehicle_type_error_msg = "";

      if ( self.vehicle_type_id == null || self.vehicle_type_id == "" || !self.vehicle_type_id.value) {
         self.vehicle_type_error_msg = "Asset Type required.";
          error = true;
      }
      
        for (var i = 0; i < self.deprows.length; i++) {
            // console.log(self.rows[i]);
            self.deprows[i].pool_error_msg = "";
            self.deprows[i].deposit_error_msg = "";

            if (self.deprows[i].pool == null || self.deprows[i].pool == '' || !self.deprows[i].pool.value) {
                    self.deprows[i].pool_error_msg = "Pool is Required.";
                    error = true;
            }

            if (self.deprows[i].deposit_required == null || self.deprows[i].deposit_required == '' || !self.deprows[i].deposit_required) {
                self.deprows[i].deposit_error_msg = "Deposit is Required.";
                error = true;
            }
        }

      if (!error){

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createVehicleTypeDepositBtn").val("Updating ...");
                $("#createVehicleTypeDepositBtn").prop("disabled", true);
                $("#cancelVehicleTypeDepositBtn").prop("disabled",true);
            } else {
                $("#createVehicleTypeDepositBtn").val("Saving ...");
                $("#createVehicleTypeDepositBtn").prop("disabled", true);
                $("#createAndContinueVehicleTypeBtn").prop("disabled", true);
                $("#cancelVehicleTypeDepositBtn").prop("disabled",true);

            }
            
            var formData = new FormData();
                formData.append('vehicle_type_id',self.vehicle_type_id.value);
                formData.append('deposit',JSON.stringify(self.deprows));
                // formData.append('id',segments[3]);

            $.ajax({
                url: process.env.ROOT_API + "/assettype-deposit/create",
                type: "POST",
                // data: {name: self.name, code: self.code, is_default: self.checkboxValue, id: segments[3]},
                data: formData,
                headers: this.ajxHeaders,
                crossDomain: true,
                processData: false,
                contentType: false,
                dataType: "json",
                success: function (data) {

                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVehicleTypeDepositBtn").val("Update");
                        $("#createVehicleTypeDepositBtn").prop("disabled", false);
                        $("#cancelVehicleTypeDepositBtn").prop("disabled",false);
                    } else {
                        
                        $("#createVehicleTypeDepositBtn").val("Save");
                        $("#createVehicleTypeDepositBtn").prop("disabled", false);
                        $("#createAndContinueVehicleTypeBtn").prop("disabled", false);
                        $("#cancelVehicleTypeDepositBtn").prop("disabled",false);

                    }
                    if (data.status == "success") {
                       
                        self.$router.push("/asset-deposit-type/list");

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                   self.loading = false;
                   if (segments[3])
                    {
                        $("#createVehicleTypeDepositBtn").val("Update");
                        $("#createVehicleTypeDepositBtn").prop("disabled", false);
                        $("#cancelVehicleTypeDepositBtn").prop("disabled",false);
                    } else {
                        
                        $("#createVehicleTypeDepositBtn").val("Save");
                        $("#createVehicleTypeDepositBtn").prop("disabled", false);
                        $("#createAndContinueVehicleTypeBtn").prop("disabled", false);
                        $("#cancelVehicleTypeDepositBtn").prop("disabled",false);

                    }
                    self.generateStatusCodeMessage(jqXHR,true,'asset-type-create')
                }
            });

      }else{
            self.errorValidationFocus();
      }

    },
    
    addDepRow: function () {

        var self = this;
        var i = self.deprows.length - 1;
        var error = false;
        self.deprows[i].pool_error_msg = "";
        self.deprows[i].deposit_error_msg = "";

        if (self.deprows[i].pool != null && self.deprows[i].pool != '' && self.deprows[i].pool.value && self.deprows[i].deposit_required != null &&
            self.deprows[i].deposit_required != '' && self.deprows[i].deposit_required) {

                self.deprows.push({
                    dep_id:0,
                    pool:'',
                    pool_error_msg:'',
                    deposit_required: '',
                    deposit_error_msg:'',
                });

        } else {
           if (self.deprows[i].pool == null || self.deprows[i].pool == '' || !self.deprows[i].pool.value) {
                self.deprows[i].pool_error_msg = "Pool is Required.";
                error = true;
            }

            if (self.deprows[i].deposit_required == null || self.deprows[i].deposit_required == '' || !self.deprows[i].deposit_required) {
                self.deprows[i].deposit_error_msg = "Deposit is Required.";
                error = true;
            }
        }
    },
    
    removeDepElement: function (index) {
        var self = this;
        if (self.deprows.length > 0) {
            if (self.deprows[index].dep_id > 0){
                if (confirm('Are you sure you want to remove this line ?')){
                    self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/deposit-line/remove",
                        type: "POST",
                        data:{
                            id:self.deprows[index].dep_id
                        },
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            console.log(data);
                            self.loading = false;
                            if (data.status == "success") {
                                self.loadVehicleTypes();
                                self.deprows.splice(index, 1);
                                // if (!self.deprows.length){
                                //      self.deprows.push({
                                //         dep_id:0,
                                //         pool:'',
                                //         pool_error_msg:'',
                                //         deposit_required: '',
                                //         deposit_error_msg:'',
                                //     });
                                // }
                                self.$swal('','Line Removed','success');
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,false,'remove-deposit-line')
                        }
                    });
                }
            }else{
                if (self.deprows.length > 1) {
                    self.deprows.splice(index, 1);
                }
            }
        }
    },

    loadVehicleTypes() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/assettypes-deposit/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                console.log(data);
                self.loading = false;
                if (data.status == "success") {
                    self.vehicle_type_id = data.content.asset_type;
                    if (data.content.deposit != undefined && data.content.deposit.length){
                        self.deprows = data.content.deposit;
                    }else{
                        self.deprows.push({
                            dep_id:0,
                            pool:'',
                            pool_error_msg:'',
                            deposit_required: '',
                            deposit_error_msg:'',
                        });
                    }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'asset-type-load-by-id')
            }
        });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AssetTypeDeposit.vue